import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function PrivateRoute({ children, allowedRoles }) {
  const { userRole, currentUser } = useAuth();

  console.log('PrivateRoute check:', {
    currentUser,
    userRole,
    allowedRoles,
    hasAccess: allowedRoles.includes(userRole)
  });

  if (!currentUser) {
    console.log('No user found, redirecting to login');
    return <Navigate to="/" />;
  }

  if (!allowedRoles.includes(userRole)) {
    console.log('User role not allowed, redirecting to login');
    return <Navigate to="/" />;
  }

  console.log('Access granted');
  return children;
}
